"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "bg-beige-400 flex justify-center px-5 py-10 md:pt-20 md:pb-20" };
const _hoisted_2 = { class: "w-full max-w-screen-xl" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h2", { class: "uppercase text-mutedpurple-800 font-black text-lg mb-3" }, "Filter results", -1);
const _hoisted_4 = { class: "grid grid-cols-3 md:gap-10 bg-beige-500 rounded-full mb-5" };
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createTextVNode)(" Everything ");
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createTextVNode)(" Courses ");
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createTextVNode)(" Events ");
const _hoisted_8 = { class: "flex flex-wrap gap-5" };
const _hoisted_9 = { class: "flex sm:flex-row flex-col gap-5 flex-auto w-full md:w-auto" };
const _hoisted_10 = { class: "sm:w-6/12 w-full" };
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "filterCategory",
    class: "label mb-1"
}, " Categories ", -1);
const _hoisted_12 = { class: "select-arrows" };
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: null }, "All", -1);
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "sm:w-6/12 w-full" };
const _hoisted_16 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "filterLevel",
    class: "label mb-1"
}, " Level ", -1);
const _hoisted_17 = { class: "select-arrows" };
const _hoisted_18 = ["disabled"];
const _hoisted_19 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: null }, "All", -1);
const _hoisted_20 = ["value"];
const _hoisted_21 = { class: "flex items-end justify-center w-full md:w-auto" };
const _hoisted_22 = { class: "grid grid-cols-2" };
const _hoisted_23 = /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
    src: "/svg/icon-grid.svg",
    alt: "Show results in grid",
    class: "w-7 h-7"
}, null, -1);
const _hoisted_24 = [
    _hoisted_23
];
const _hoisted_25 = /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
    src: "/svg/icon-list.svg",
    alt: "Show results in a list",
    class: "w-7 h-7"
}, null, -1);
const _hoisted_26 = [
    _hoisted_25
];
const vue_3 = require("vue");
const ListingFilterTab_vue_1 = __importDefault(require("./ListingFilterTab.vue"));
const Listings_1 = require("../../stores/Listings");
const Categories_1 = require("../../stores/Categories");
const reactivity_1 = require("@vue/reactivity");
const get_1 = __importDefault(require("lodash/get"));
const vue_4 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ListingsFilter',
    setup(__props) {
        const store = (0, Listings_1.useListingsStore)();
        const categoriesStore = (0, Categories_1.useCategoriesStore)();
        function changeType(newType) {
            store.$state.type = newType;
            store.resetListings();
            store.loadMore();
        }
        function changeView(newView) {
            store.$state.view = newView;
        }
        function onChangeCategory() {
            store.$state.level = null;
            (0, vue_3.nextTick)(() => {
                store.resetListings();
                store.loadMore();
            });
        }
        const activeCategory = (0, vue_4.ref)(null);
        const subCategory = (0, vue_4.ref)(null);
        (0, vue_4.watch)(activeCategory, (newCategory) => {
            store.$state.category = newCategory;
            onChangeCategory();
        });
        (0, vue_4.watch)(subCategory, (newCategory) => {
            store.$state.level = newCategory;
            store.resetListings();
            store.loadMore();
        });
        const subCategories = (0, reactivity_1.computed)(() => {
            if (!store.category) {
                return [];
            }
            return (0, get_1.default)(categoriesStore.categories.find((cat) => {
                return cat.slug === store.category;
            }), 'children');
        });
        (0, vue_3.onMounted)(() => {
            categoriesStore.fetchCategories().then(() => {
                store.loadMore();
            });
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("section", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    _hoisted_3,
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createVNode)(ListingFilterTab_vue_1.default, {
                            value: null,
                            current: (0, vue_2.unref)(store).$state.type,
                            onClick: changeType
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                _hoisted_5
                            ]),
                            _: 1
                        }, 8, ["current"]),
                        (0, vue_2.createVNode)(ListingFilterTab_vue_1.default, {
                            value: "course",
                            current: (0, vue_2.unref)(store).$state.type,
                            onClick: changeType
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                _hoisted_6
                            ]),
                            _: 1
                        }, 8, ["current"]),
                        (0, vue_2.createVNode)(ListingFilterTab_vue_1.default, {
                            value: "event",
                            current: (0, vue_2.unref)(store).$state.type,
                            onClick: changeType
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                _hoisted_7
                            ]),
                            _: 1
                        }, 8, ["current"])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                _hoisted_11,
                                (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                        id: "filterCategory",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((activeCategory).value = $event))
                                    }, [
                                        _hoisted_13,
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(categoriesStore).categories, (category) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                value: category.slug
                                            }, (0, vue_2.toDisplayString)(category.name), 9, _hoisted_14));
                                        }), 256))
                                    ], 512), [
                                        [vue_2.vModelSelect, activeCategory.value]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                _hoisted_16,
                                (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                        id: "filterLevel",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((subCategory).value = $event)),
                                        disabled: (0, vue_2.unref)(subCategories) && (0, vue_2.unref)(subCategories).length === 0
                                    }, [
                                        _hoisted_19,
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(subCategories), (category) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                value: category.slug
                                            }, (0, vue_2.toDisplayString)(category.name), 9, _hoisted_20));
                                        }), 256))
                                    ], 8, _hoisted_18), [
                                        [vue_2.vModelSelect, subCategory.value]
                                    ])
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                            (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    onClick: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(($event) => (changeView('grid')), ["prevent"])),
                                    class: (0, vue_2.normalizeClass)(["rounded-l p-3 transition-colors h-[50px] focusable", (0, vue_2.unref)(store).$state.view === 'grid' ? 'bg-beige-200' : 'bg-beige-500'])
                                }, _hoisted_24, 2),
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    onClick: _cache[3] || (_cache[3] = (0, vue_2.withModifiers)(($event) => (changeView('list')), ["prevent"])),
                                    class: (0, vue_2.normalizeClass)(["rounded-r p-3 transition-colors h-[50px] focusable", (0, vue_2.unref)(store).$state.view === 'list' ? 'bg-beige-200' : 'bg-beige-500'])
                                }, _hoisted_26, 2)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
